const API_ENDPOINT = 'https://api.zanox.com/json/2011-03-01/';
// const API_ENDPOINT = 'https://api.awin.com/json/2011-03-01/';
const AUTH2_TOKEN = '69506b3c-939e-4f3a-b047-c410e6c70faf';
const CONNECT_ID = 'E95346E4C2F8207765E9';
// const API_COUPONS = 'incentives/?connectid=' + CONNECT_ID + '&incentiveType=coupons&region=BR&adspace=2289585&callback=JSONP_CALLBACK';
const API_COUPONS = 'incentives/?connectid=' + CONNECT_ID + '&incentiveType=coupons&region=BR';
const API_STORES = 'programs/?region=BR&connectid=' + CONNECT_ID + '&items=50&hasproducts=true';
import axios from 'axios'
const jsonp = require('jsonp');
const functions = require('../utils/functions')

function getCoupons(callback){
  jsonp(API_ENDPOINT + API_COUPONS + '&callback=JSONP_CALLBACK', null, callback);
}

function getStoreCoupons(storeId, callback)
{
  jsonp(API_ENDPOINT + API_COUPONS + '&program=' + storeId + '&callback=JSONP_CALLBACK', null, callback);
}

function getStores(callback){
  jsonp(API_ENDPOINT + API_STORES + '&callback=JSONP_CALLBACK', null, callback);
}

function getStore(id, callback){
  jsonp(API_ENDPOINT + 'programs/program/' + id + '?connectid=' + CONNECT_ID + '&callback=JSONP_CALLBACK', null, callback);
}

function convertStore(store){
  var slug = functions.stringToSlug(store.name + '-' + store['@id']);
  return {
    'StoreId': store['@id'],
    'originalId': store['@id'],
    'name': store.name,
    'slug': slug,
    'image': store.image,
    'description': store.terms,
    'url': store.url,
    'storeType': 'awin'
  }
}

function convertCoupon(coupon, StoreId = null, CategoryId = null){
  var slug = functions.stringToSlug(coupon.program['$'] + '-' + coupon.program['@id']);
  var link = null;
  if(coupon.admedia.admediumItem.trackingLinks != ""){
    link = coupon.admedia.admediumItem.trackingLinks.trackingLink[0].ppc;
  }
  return {
    'CouponId': coupon['@id'],
    'StoreId': StoreId,
    'CategoryId': CategoryId,
    'category': null,
    'store': coupon.program['$'],
    'slug': slug,
    'originalId': coupon['@id'],
    'couponType': 'awin',
    'description': coupon.name,
    'trackingLink': link,
    'image': false,
    'value': coupon.percentage,
    'code': coupon.couponCode,
    'dateBegin': coupon.endDate,
    'dateEnd': coupon.endDate
  }
}

export default {
  getCoupons,
  getStore,
  getStores,
  convertCoupon,
  convertStore,
  getStoreCoupons
}


// WEBPACK FOOTER //
// ./src/drivers/awin.js